import { useEffect, useState } from 'react';
import { identifyFromToken } from '../analytics/logrocket';
import { Loader } from '../components/loader/Loader';
import { userLightNote } from '../constants/constants';
import { getStoredToken } from '../helpers/localStorageToken';
import { ILoginResponse, IUser } from '../interfaces/authInterface';
import { login } from '../service';
import AuthContext from './AuthContext';

function AuthProvider({ children }: { children: React.ReactNode }) {
  const [token, setToken] = useState<string | null>(null);
  const [initializing, setInitializing] = useState<boolean>(true);

  useEffect(() => {
    async function loadStoredToken() {
      try {
        const stored = await getStoredToken();
        if (stored) {
          setToken(stored);
          identifyFromToken(stored);
        }
      } finally {
        setInitializing(false);
      }
    }

    loadStoredToken();
  }, []);

  const signIn = async (
    newUser: IUser,
    callback: (value: ILoginResponse) => void
  ) => {
    const resp = await login(newUser.username, newUser.password);
    if (resp.token) {
      setToken(resp.token);
      identifyFromToken(resp.token);
    }
    callback(resp);
  };

  const logoutUser = () => {
    localStorage.removeItem(userLightNote);
    setToken(null);
  };

  const value = { token, signIn, logoutUser, initializing };

  return (
    <AuthContext.Provider value={value}>
      {initializing ? <Loader isAuthLoader /> : children}
    </AuthContext.Provider>
  );
}

export default AuthProvider;
